 export default {
    
    //PROD
    apiKey: "AIzaSyAyCGTaMd205iTcdrIkxZ2jByoGF6KPmNA",
    authDomain: "atos-web.firebaseapp.com",
    databaseURL: "https://atos-web.firebaseio.com",
    projectId: "atos-web",

    // // //DEV-HMG
    // apiKey: "AIzaSyAngrCbszoLvLVPEhU0qrK8YLwWH7kLONg",
    // authDomain: "atos-web-dev.firebaseapp.com",
    // databaseURL: "https://atos-web.firebaseio.com",
    // projectId: "atos-web-dev",


  };
  